// Dependencies
import React from 'react';

// import { EVENT_TYPE, FORM_NAME } from '../../../../../lib/analytics-constants';
import { RentVsBuyInput } from '../../../../../lib/utils';
import { LEGACY_FIELD_NAMES } from '../../../analytics-constants';
import TaxFilingStatusInput from '../tax-filing-status';

const CONTROL_PANEL = 'controlPanel';

const analyticsPayload = {
  enabled: true,
  payload: {
    legacy: {
      formName: CONTROL_PANEL,
      fieldName: LEGACY_FIELD_NAMES.TAX_FILING_STATUS,
    },
    // bedrock: {
    //   eventType: EVENT_TYPE.TAX_FILING_STATUS_UPDATED,
    //   form_name: FORM_NAME.RENT_VS_BUY_CALCULATOR,
    //   was_prefilled: true,
    //   page_number: null,
    //   total_pages: null,
    // },
  },
};
const TaxFilingStatusInputWithAnalytics: React.FC<RentVsBuyInput> = ({
  label,
  tooltip,
  className,
}) => {
  return (
    <TaxFilingStatusInput
      label={label}
      tooltip={tooltip}
      analytics={analyticsPayload}
      className={className}
    />
  );
};

export default TaxFilingStatusInputWithAnalytics;
